<template>
    <div class="card border-left-primary shadow h-100 py-2 mx-auto" style="width: 350px;">
        <div class="card-body px-3">
            <div class="row no-gutters align-items-center">
                <div class="col-auto mr-3" v-if="agent.status == 'online'">
                    <font-awesome-icon :icon="['fas', 'user']" class="fa-2x text-success" />
                </div>
                <div class="col-auto mr-4" v-else-if="agent.status == 'busy'">
                    <font-awesome-layers>
                        <font-awesome-icon :icon="['fas', 'user']" class="fa-2x text-primary" />
                        <font-awesome-icon :icon="['fas', 'phone']" class="text-primary" transform="shrink-6 right-22 up-6"/>
                    </font-awesome-layers>
                </div>
                <div class="col-auto mr-4" v-else-if="agent.status == 'disabled'">
                    <font-awesome-layers>
                        <font-awesome-icon :icon="['fas', 'user']" class="fa-2x text-danger" />
                        <font-awesome-icon :icon="['fas', 'phone-slash']" class="text-danger" transform="shrink-6 right-22 up-6"/>
                    </font-awesome-layers>
                </div>
                <div class="col-auto mr-4" v-else>
                    <font-awesome-icon :icon="['fas', 'user']" class="fa-2x text-disabled" />
                </div>
                <div class="col-7">
                    <div class="text-lg font-weight-bold mb-1 pr-2">{{ agent.name}}</div>
                    <div class="text-md mb-0 text-gray-800">{{ statusMessage }} since <br><span class="badge badge-light badge-pill px-0">{{ statusTime }}</span></div>
                </div>
                <div class="col-auto" v-if="agent.status == 'online' && agent.id != user.username">
                    <button class="btn btn-success" @click="callAgent(agent.id)"><font-awesome-icon :icon="['fas', 'phone-alt']" /> Call</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from "@/utils/event-bus"
export default {
    name: 'AgentStatus',
    props: ['agent'],
    computed: {
        ...mapGetters(["user"]),
        statusClass() {
            switch (this.agent.status) {
                case 'online':
                    return 'text-primary';
                case 'disabled':
                    return 'text-warning';
                case 'busy':
                    return 'text-success';
                case 'offline':
                    return 'text-danger';
                default:
                    return 'text-warning';
            }
        },
        statusMessage() {
            switch (this.agent.status) {
                case 'online':
                    return 'Online';
                case 'disabled':
                    return 'Disabled';
                case 'busy':
                    return 'In Call';
                case 'offline':
                    return 'Offline';
                default:
                    return 'Unknown (' + this.agent.status + ')';
            }
        },
        statusTime() {
            let today = new Date().toLocaleString().split(', ')[0];
            let a_date = new Date(this.agent.timestamp * 1000).toLocaleString();
            let day = a_date.split(', ')[0];
            let time = a_date.split(', ')[1];
            if (day == today) {
                return time
            }
            else {
                return day + ', ' + time; 
            }
        }
    },
    methods: {
        callAgent(to) {
            EventBus.$emit('callAgent', to);
        }
    }
}
</script>